import React from 'react';
import { motion } from 'framer-motion';
import { useInterfaceLanguage } from '../hooks/useInterfaceLanguage';
import { InterfaceLanguageCode } from '../constants/interfaceLanguages';
import './InterfaceLanguageToggle.css';

interface InterfaceLanguageToggleProps {
  dark?: boolean;
  className?: string;
}

// Compact FR/EN segmented toggle for the pre-login pages (landing + mobile).
// Distinct from InterfaceLanguageSelector (a <select>, used in Profile settings) —
// this one fits the hero-header icon-button row instead of a settings list.
const InterfaceLanguageToggle: React.FC<InterfaceLanguageToggleProps> = ({ dark = false, className = '' }) => {
  const { language, setLanguage, availableLanguages } = useInterfaceLanguage();

  return (
    <div
      className={`ilt-toggle ${dark ? 'ilt-toggle--dark' : ''} ${className}`}
      role="group"
      aria-label="Interface language"
    >
      {availableLanguages.map((lang) => (
        <motion.button
          key={lang.code}
          type="button"
          className={`ilt-toggle__opt ${language === lang.code ? 'ilt-toggle__opt--active' : ''}`}
          onClick={() => setLanguage(lang.code as InterfaceLanguageCode)}
          aria-pressed={language === lang.code}
          aria-label={lang.name}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {lang.code.toUpperCase()}
        </motion.button>
      ))}
    </div>
  );
};

export default InterfaceLanguageToggle;
